import _findIndex from 'lodash/findIndex';

/**
 * @desc  ActivityService class.
 * @ngInject
 */
export default class TalkService {
  /**
   * Constructor of the class.
   *
   * @param {$rootScope} $rootScope
   * @param {$q} $q
   * @param {$log}  $log
   * @param {$http} $http
   */
  constructor(
    $rootScope, $q, $log, $http
  ) {
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.$log = $log;
    this.$http = $http;

    this.talks = [];

    this.$rootScope.$on('scr.select', () => {
      this.talks.splice(0, this.talks.length);
    });
  }

  add(options) {
    const copyTalk = {};
    angular.copy(options.data, copyTalk);
    return this.$http({
      method: 'POST',
      url: `/SCR/employee/${this.$rootScope.me.employeeId}/talk`,
      data: {talk: options.data}
    }).then(result => {
      copyTalk.id = String(result.data.id);
      if (options.addToLocal) {
        copyTalk.students = copyTalk.studentObjects;
        copyTalk.employee = this.$rootScope.me;
        copyTalk.employee.id = this.$rootScope.me.employeeId;
        copyTalk.employee.fullName = this.$rootScope.me.name;
        this.talks.unshift(copyTalk);
      }

      return true;
    }, err => this.$q.reject(err));
  }

  getAll(fromServer = false) {
    if (this.talks.length > 0 && !fromServer) {
      return this.$q.resolve(this.talks);
    }

    return this.$http({
      method: 'GET',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/talks`
    }).then(result => {
      this.talks = result.data.talks;
      return this.talks;
    }, err => this.$q.reject(err));
  }

  get(id) {
    return this.$http({
      method: 'GET',
      url: `/SCR/employee/${this.$rootScope.me.employeeId}/talk/${id}`
    }).then(result => result.data.talk[0], err => this.$q.reject(err));
  }

  edit(options) {
    const copyTalk = {};
    angular.copy(options.data, copyTalk);
    return this.$http({
      method: 'PUT',
      url: `/SCR/employee/${this.$rootScope.me.employeeId}/talk/${options.data.id}`,
      data: {talk: options.data}
    }).then(() => {
      const id = _findIndex(this.talks, ['id', copyTalk.id]);
      copyTalk.students = copyTalk.studentObjects;
      this.talks[id] = copyTalk;
      return true;
    }, err => this.$q.reject(err));
  }

  delete(options) {
    return this.$http({
      method: 'DELETE',
      url: `/SCR/employee/${this.$rootScope.me.employeeId}/talk/${options.data}`
    }).then(result => {
      const idToRemove = _findIndex(this.talks, ['id', options.data]);
      this.talks.splice(idToRemove, 1);
      return result;
    }, err => this.$q.reject(err));
  }

  getStudents(id, params = {}) {
    return this.$http({
      method: 'GET',
      url: `/SCR/talks/${id}/unassignedStudents`,
      params: {
        limit: params.limit,
        offset: params.offset,
        condition: params.query
      }
    }).then(result => result, err => this.$q.reject(err));
  }
}
